import React, { useState, useEffect } from 'react';
export default function Profile(_ref) {
  var pageName = _ref.pageName,
    appProps = _ref.appProps,
    pageTitle = _ref.pageTitle,
    userNeedsEmailConfirmation = _ref.userNeedsEmailConfirmation,
    resendConfirmationPath = _ref.resendConfirmationPath,
    casLoading = _ref.casLoading;
  var translations = appProps.translations,
    getAccountInfoPath = appProps.getAccountInfoPath,
    user = appProps.user,
    flashMessage = appProps.flashMessage;
  function resendConfirmation() {
    Rails.ajax({
      type: 'POST',
      url: resendConfirmationPath,
      dataType: 'json',
      success: function success(result) {
        if (result.success) {
          flashMessage.show(translations.account.email_confirmation_sent);
        }
      }
    });
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "section-title"
  }, /*#__PURE__*/React.createElement("h3", null, pageTitle)), /*#__PURE__*/React.createElement("div", {
    className: "account ".concat(pageName)
  }, /*#__PURE__*/React.createElement("div", {
    id: "contact_info",
    className: "card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "avatar-wrapper flex-box items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "avatar"
  }, !casLoading && user.avatar && /*#__PURE__*/React.createElement("img", {
    src: user.avatar
  }), !casLoading && !user.avatar && /*#__PURE__*/React.createElement("i", {
    className: "fa-light fa-circle-user"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "fields-wrapper"
  }, !casLoading && user.fullname && user.fullname !== '' && /*#__PURE__*/React.createElement("div", {
    className: "field"
  }, /*#__PURE__*/React.createElement("label", null, translations.account.full_name), /*#__PURE__*/React.createElement("div", null, user.fullname)), /*#__PURE__*/React.createElement("div", {
    className: "field"
  }, /*#__PURE__*/React.createElement("label", null, translations.account.email_address), !casLoading && /*#__PURE__*/React.createElement("div", null, user.email)), /*#__PURE__*/React.createElement("div", {
    className: "field"
  }, /*#__PURE__*/React.createElement("a", {
    href: "/account/manage",
    rel: "nofollow noindex noreferrer",
    target: "_blank",
    className: "flex-box items-center"
  }, /*#__PURE__*/React.createElement("b", null, translations.account.manage_account), /*#__PURE__*/React.createElement("i", {
    className: "fa-light fa-pen-to-square",
    style: {
      marginLeft: 10
    }
  })))))), !casLoading && userNeedsEmailConfirmation && !user.confirmed && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, translations.account.email_not_confirmed), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "button",
    style: {
      marginTop: 15
    },
    onClick: resendConfirmation
  }, translations.account.resend_email_confirmation)));
}